import { useContext } from "react";
import { UserContext } from "hooks/UserContext";

export function PermissionProvider({ permissionId, children }) {
	const { user } = useContext(UserContext);
	// console.log("PermissionProvider ===> user", user);
	const pageRoles = user?.buttons ?? [];

	const hasPermission = (permissionId) => {
		return pageRoles.includes(permissionId);
	};

	if (hasPermission(permissionId)) {
		return children;
	}

	return null;
}
